import React from 'react'
import './HeaderCss.css'

export default function Header() {
  return (
    <header className="head">
      <div className='forLogo'>
        <span className='logo'>Палата58550</span>
      </div>
    </header>
  )
}